import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import { FeedCard, CardButton } from 'dabbl-react-components';
import ShopriteCard from '../../../../../components/ShopriteCard';

class BufferToLoyaltyCard extends Component {

  static propTypes = {
    // Required
    couponAmount: PropTypes.number.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onWaitClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onAddClick: () => {},
    onWaitClick: () => {},
  }

  render() {
    const {
      couponAmount,
      onAddClick,
      onWaitClick,
    } = this.props;

    const nextGoalAmount = couponAmount === 1 ? 3 : ((couponAmount+3 <= 9) ? couponAmount+3 : false);

    return (
      <FeedCard className="BufferToLoyaltyCard">
        <div className="BufferToLoyaltyCard_contentContainer">

          <ShopriteCard className="BufferToLoyaltyCard_cardImg"/>

          <div className="BufferToLoyaltyCard_text">
            <div className="BufferToLoyaltyCard--text-bold">
              Congratulations!
            </div>
            <div>You've earned ${couponAmount}!</div>
          </div>

          <div className="BufferToLoyaltyCard--fixToBottom">
            <CardButton
              className="BufferToLoyaltyCard_btn"
              onClick={() => onAddClick()} // not adding coupon anymore
            >
              Add ${couponAmount} Coupon
            </CardButton>

            {nextGoalAmount && (
              <CardButton
                className="BufferToLoyaltyCard_btn"
                onClick={() => onWaitClick(nextGoalAmount)}
              >
                Wait until ${nextGoalAmount}
              </CardButton>
            )}
          </div>
        </div>
      </FeedCard>
    );
  }
}

export default BufferToLoyaltyCard;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/components/CampaignCards/CouponNotificationCard/CouponNotificationCard.js